import "./ThemeModeSwitcher.scss";

import { Dropdown } from "react-bootstrap";

import type { ThemeModeType } from "../../contexts/theme-mode/ThemeModeProvider";
import { useThemeMode } from "../../contexts/theme-mode/ThemeModeProvider";
import { SwitchModeIcon } from "../icons/SwitchModeIcon";
import { ThemeDarkIcon } from "../icons/ThemeDarkIcon";
import { ThemeLightIcon } from "../icons/ThemeLightIcon";
import { ThemeSystemIcon } from "../icons/ThemeSystemIcon";

const ThemeModeSwitcher = () => {
  const { menuMode, updateMode, updateMenuMode } = useThemeMode();
  const switchMode = (_mode: ThemeModeType) => {
    updateMenuMode(_mode);
    updateMode(_mode);
  };

  return (
    <Dropdown>
      <Dropdown.Toggle variant="outline-light" className="no-arrow">
        <SwitchModeIcon />
      </Dropdown.Toggle>
      <Dropdown.Menu
        align="end"
        renderOnMount={false}
        className="theme-dropdown"
      >
        <Dropdown.Item
          className={menuMode === "light" ? "active" : ""}
          onClick={() => switchMode("light")}
        >
          <span>
            <ThemeLightIcon size={16} />
            Light
          </span>
        </Dropdown.Item>
        <Dropdown.Item
          className={menuMode === "dark" ? "active" : ""}
          onClick={() => switchMode("dark")}
        >
          <span>
            <ThemeDarkIcon size={16} />
            Dark
          </span>
        </Dropdown.Item>
        <Dropdown.Item
          className={menuMode === "system" ? "active" : ""}
          onClick={() => switchMode("system")}
        >
          <span>
            <ThemeSystemIcon size={16} />
            System
          </span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export { ThemeModeSwitcher };
